import script from "./ProcessFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessFlow.vue?vue&type=script&setup=true&lang=js"

import "./ProcessFlow.vue?vue&type=style&index=0&id=62aeec98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62aeec98"]])

export default __exports__